export const queryKeys = {
  // Consolidate all your query keys here
  auth: {
    testApi: ["auth", "test-api"] as const,
  },
  registrations: {
    detail: (id: string | number) => ["registrations", "detail", String(id)] as const,
    list: (params: { page: number; limit: number; search?: string }) =>
      ["registrations", "list", params] as const,
    stats: ["registrations", "stats"] as const,
  },
} as const;
